export default "__VITE_ASSET__C9ab7Zsh__"